import React, { useState } from 'react';
import {
  DialogProps, FormControl, FormControlLabel, Radio, RadioGroup,
} from '@mui/material';
import Modal from '../components/modals/modal';

type OmitProps = 'title' | 'error';

export const SINGLE_TASK_VALUE = 'singleTask';
export const SERIES_VALUE = 'fullSeries';

export type Option = typeof SINGLE_TASK_VALUE | typeof SERIES_VALUE
export type Action = {
  changeType: 'Update' | undefined,
  rruleUpdate: boolean
};

export interface Props extends Omit<DialogProps, OmitProps> {
  open: boolean;
  onPositive: (selectedOption: Option) => Promise<void> | void;
  onNegative: () => void;
  action?: Action['changeType'];
}

const TaskRecurrenceDialog = ({
  open,
  onPositive,
  onNegative,
  action = 'Update',
}: Props) => {
  const [radioValue, setRadioValue] = useState<Option>(SINGLE_TASK_VALUE);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedOption = (event.target as HTMLInputElement).value as Option;
    setRadioValue(selectedOption);
  };
  const handlePositive = () => onPositive(radioValue);

  return (
    <Modal
      onPositive={handlePositive}
      onNegative={onNegative}
      title={`${action} Task Recurrence`}
      open={open}
      maxWidth="xs"
    >
      <FormControl>
        <RadioGroup
          name="task-series-scope"
          value={radioValue}
          onChange={handleChange}
        >
          <FormControlLabel value={SINGLE_TASK_VALUE} control={<Radio />} label={`${action} this task only`} />
          <FormControlLabel
            value={SERIES_VALUE}
            control={<Radio />}
            label={`${action} this and future tasks`}
          />
        </RadioGroup>
      </FormControl>
    </Modal>
  );
};
export default TaskRecurrenceDialog;
